/** Ortak bileşen metinleri (ölçü kartı, sayı bağlantısı, durum rozeti, hızlı önizleme). Resmî "siz" dili. */
export const commonText = {
  /** Sayım tavanına takılan sayının erişilebilir metni */
  capped: (n: string) => `${n} ve üzeri (sayım tavanı)`,
  /** Ölçü kartının erişilebilir adı: sayı + etiket + not, ardından eylem */
  openList: (label: string, n: string) => `${label}: ${n}. Listeyi aç`,
  /** Tablo hücresindeki sayı bağlantısı: "Web formu — nitelikli: 3. Listeyi aç" */
  countLink: (context: string, n: string) => `${context}: ${n}. Listeyi aç`,
  /** Ölçü kartında sayının süzülmüş listeye açıldığını söyleyen ok (görsel; ad kartın adında) */
  opensList: 'Süzülmüş listeyi aç',
  followUp: {
    none: 'Takip planlanmadı',
    today: 'Bugün',
    tomorrow: 'Yarın',
    overdue: (days: number) => `${String(days)} gün gecikti`,
  },
  preview: {
    open: (title: string) => `${title} — hızlı önizleme`,
    button: 'Önizle',
    noAssessment: 'Değerlendirme yok',
    logContact: 'Görüşme kaydet',
    followUp: 'Takip görevi',
    taskCreated: 'Takip görevi oluşturuldu.',
  },
} as const;
